export default "__VITE_ASSET__CQYXldxG__"